import { createNode } from '@glueapp/graph-types';

export const TextToNumber = createNode({
    id: 'Text to Number',
    name: 'Text to Number',
    category: 'Conversion',
    description: 'Tries to convert a text into a number. If it fails the number will be 0 and conversion successful will be false',
    aiDescription:
        'Parses a text string into a number. Connect a string to the "Text" input port; the "Number" output port provides the parsed value and "Conversion successful" indicates whether parsing succeeded.',
    color: '#5aaa92',
    integration: undefined,
    inPorts: {
        Text: {
            kind: 'string',
        },
    },
    outPorts: {
        Number: { kind: 'number' },
        'Conversion successful': {
            kind: 'boolean',
        },
    },
    execute: function (input) {
        const text = input.inPorts.Text;
        const result = parseFloat(text);
        if (isNaN(result) || result === null) {
            return { output: { Number: 0, 'Conversion successful': false } };
        } else {
            return { output: { Number: result, 'Conversion successful': true } };
        }
    },
});
